export default "<div id=\"toasterAnchor\" [ngClass]=\"toastClassMap\"></div>\n";